import {
  API_CALL,
  API_CALL_SUCCESS,
  CHECKOUT_ADD_ITEM,
  CHECKOUT_APPLY_PARTNERSHIP_STATUS,
  CHECKOUT_APPLY_PROMO_CODE,
  CHECKOUT_APPLY_PROMO_CODE_FAILED,
  CHECKOUT_APPLY_VELOCITY_BURN,
  CHECKOUT_CLEAR_CART,
  CHECKOUT_FETCHING_PROMO_CODE,
  CHECKOUT_HIDE_PROMO_CORPORATE_BENEFITS,
  CHECKOUT_INITIALISE,
  CHECKOUT_SET_MODE,
  CHECKOUT_MODIFY_FLIGHT_SEARCH_VIEW,
  CHECKOUT_PROCESS_CANCEL,
  CHECKOUT_PROCESS_FAILURE,
  CHECKOUT_PROCESS_START,
  CHECKOUT_PROCESS_SUCCESS,
  CHECKOUT_REMOVE_ITEM,
  CHECKOUT_RESET_PROMO_CODE,
  CHECKOUT_RESTORE_CART,
  CHECKOUT_RESTORE_FORM,
  CHECKOUT_RESTORE_PAYMENT,
  CHECKOUT_SET_FORM,
  CHECKOUT_CLEAR_TRAVELLER_FORM,
  CHECKOUT_SET_RESTORE_CART_STATUS,
  CHECKOUT_TOGGLE_DEV_TOOLS,
  CHECKOUT_SET_POST_PURCHASE,
  CHECKOUT_ADD_ROOMS_TO_BE_CONNECTED,
  CHECKOUT_SET_SPECIAL_REQUEST,
  CHECKOUT_SET_VELOCITY_BURN_MODAL_STATUS,
  CHECKOUT_SET_VELOCITY_SSO,
  CHECKOUT_SHOW_PROMO_CORPORATE_BENEFITS,
  CHECKOUT_TOGGLE_CREDIT,
  CHECKOUT_UPDATE_ARRIVAL_FLIGHT_NUMBER,
  CHECKOUT_UPDATE_BUNDLE_ITEM_PRICING,
  CHECKOUT_UPDATE_CS_DEPOSIT_OVERRIDE,
  CHECKOUT_UPDATE_EXPERIENCE_ITEM,
  CHECKOUT_UPDATE_HOTEL_ITEM_PRICING,
  CHECKOUT_UPDATE_ITEM,
  CHECKOUT_UPDATE_PAYMENT_SELECTION,
  CHECKOUT_SHOW_PROMO_FRIENDS_AND_FAMILY,
  CHECKOUT_HIDE_PROMO_FRIENDS_AND_FAMILY,
  CHECKOUT_CLEAR_VELOCITY_BURN,
  CHECKOUT_SET_MULTI_CART_ITEM_MODE,
  CHECKOUT_REMOVE_TRAVELLER_SCHEMA,
  CHECKOUT_SET_MERCHANT_FEE_PAYMENT_TYPE,
  CHECKOUT_RESET_FORM,
  CHECKOUT_CLEAR_CART_RESTORE_PRICE,
  CHECKOUT_AGENT_BOOKING_DETAILS,
  CHECKOUT_SET_LUXPLUS_UPSELL_DATA,
  CHECKOUT_SET_STRIPE_PAYMENT_METHOD,
  CHECKOUT_BUSINESS_BOOKING_DETAILS,
  CHECKOUT_ADD_ARRIVAL_DETAILS,
  CHECKOUT_SET_ARRIVAL_DETAILS_TIME,
  CHECKOUT_SET_ARRIVAL_DETAILS_FLIGHT_NUMBER,
  ACTIVATE_REBOOKING,
  CHECKOUT_SET_PAYTO_BANK,
  CHECKOUT_SET_COMMS_RESUBSCRIBE,
  CHECKOUT_FETCHING_PAYMENT_LINK,
  CHECKOUT_SET_PAYMENT_LINK,
  CHECKOUT_FETCHING_PAYMENT_LINK_FAILED,
  CHECKOUT_SET_ORDER_ID,
  CHECKOUT_RESET_COMMISSION,
  CHECKOUT_TOGGLE_LOYALTY_SIGNUP,
  CHECKOUT_REMOVE_ROOMS_TO_BE_CONNECTED,
  CHECKOUT_SET_HAS_CAR_HIRE_INTENTION,
  CHECKOUT_SET_AGENT_HUB_PAYMENT_SETUP,
  SET_BEDBANK_SESSION,
  CHECKOUT_CLEAR_RESTORED_PROMO_CODE,
  CHECKOUT_CLEAR_RESTORED_USE_CREDIT,
  CHECKOUT_TOGGLE_GIFT_CARD,
  CHECKOUT_SET_APPROVAL_REQUEST_ID,
  CHECKOUT_CLEAR_APPROVAL_REQUEST_ID,
  CHECKOUT_RESTORE_LOYALTY_UPDATE_POINTS_TO_BURN,
  SET_PAYPAL_PAYMENT_TYPE,
  CHECKOUT_UPDATE_TRAVELLER_FORM_PREREQUISITE,
  CHECKOUT_REMOVE_TRAVELLER_FORM_PREREQUISITE,
  CHECKOUT_TOGGLE_FAILED_ITEMS,
  CHECKOUT_LOYALTY_UPDATE_POINTS_TO_BURN,
  CHECKOUT_SET_TRAVELLER_FORM_INIT_STATUS,
} from 'actions/actionConstants'
import {
  CHECKOUT_FETCH_BEDBANK_EXISTING_ORDER,
  CHECKOUT_INIT_BEDBANK_CHANGE_DATES_SESSION,
  CHECKOUT_REQUEST_CORPORATE_BENEFITS_PROMO,
  CHECKOUT_REQUEST_FRIENDS_AND_FAMILY_PROMO,
  FETCH_BEDBANK_OFFER,
  FETCH_BEDBANK_OFFERS_RATES, FETCH_COMMMISSION_PROMO, FETCH_TRAVELLER_FORM_SCHEMA,
  FETCH_VELOCITY_MEMBER_DETAILS,
  LOG_PAYMENT_EVENT,
  UPDATE_BEDBANK_SESSION,
  CREATE_STRIPE_PAYMENT_METHOD,
  CHECKOUT_CREATE_CART_QUOTE,
  CHECKOUT_UPDATE_CART_QUOTE,
  FETCH_COMMISSION_PROMO_CODE,
  FETCH_BEDBANK_SESSION,
} from 'actions/apiActionConstants'
import { Bedbank } from '@luxuryescapes/contract-svc-bedbank'
import { enquiry, getEnquiry, CreateReservationEnquiryProps } from 'api/bedbank'
import { getRatesForBedbankOffer, getRatesForBedbankOffers } from 'api/bedbankRates'
import { getOfferById } from 'api/offer'
import {
  RestrictedPromoRequestData,
  getPromoV2,
  getReferralPromo,
  registerCorporateBenefits,
  registerFriendsAndFamily,
} from 'api/promo'
import { retrieveTravellerDetailsForm } from 'api/traveller'
import { mapHotelLoyaltyProgramTitle } from 'api/mappers/travellerMapper'
import { getVelocityMemberProfile } from 'api/velocity'
import { getTravellerFormSchemaRequest, getTravellerFormSchemaRequestKey } from 'checkout/selectors/request/travellerSchema'
import getCheckoutTotalsView from 'checkout/selectors/payment/getCheckoutTotalsView'
import getCreditPayableAmount from 'checkout/selectors/payment/getCreditPayableAmount'
import { checkoutAccommodationOfferView } from 'checkout/selectors/view/accommodation'
import { showSnackbar } from 'LuxKit/Snackbar/AppSnackbar'
import config from 'constants/config'
import { OFFER_TYPE_BED_BANK } from 'constants/offer'
import { VIRGIN_VELOCITY_BURN_MINIMUM } from 'constants/partnerships'
import {
  CREDIT_PAYMENT_TYPE, PAYLATER_PAYMENT_TYPE,
  PAYMENT_OPTIONS,
  PaymentMethod, PAYPAL_PAYMENT_TYPE,
  PROMO_PAYMENT_TYPE,
  SECURE_PAYMENT_OPTIONS,
  STRIPE_PAYMENT_TYPE,
} from 'constants/payment'
import equal from 'fast-deep-equal'
import { deduceGenderFromTitle } from 'lib/tours/tourUtils'
import { arrayToMap, groupBy, nonNullable, sum, without } from 'lib/array/arrayUtils'
import { ExperienceDetails } from 'lib/checkout/experiences/cart'
import { paymentMethodsToString } from 'lib/payment/paymentUtils'
import moment from 'moment/moment'
import { Dispatch } from 'redux'
import { AppDispatch } from '../store'
import { getBedbankRateKey } from './BedbankOfferActions'
import { genericOrderErrorModalOpen, bedbankHotelPriceChangeModalOpen, showSecurePaymentModal } from './UiActions'
import { clearFormStateCheckout, clearFormStateSnapshot } from 'storage/checkout'
import { getPaymentMethodAvailability } from 'checkout/selectors/payment/paymentType'
import { getCartFlightJourneys } from 'checkout/selectors/payment/flights'
import { sortTravellers } from 'checkout/lib/utils/form/sortTravellers'
import { SnowplowEvent } from 'analytics/snowplow/events'
import { createPaymentLink, CreatePaymentLinkPayload, postPaymentEventLog } from 'api/payment'
import { Stripe, CreatePaymentMethodFromElements } from '@stripe/stripe-js/types/stripe-js'
import { getFullOrder } from 'api/order'
import { generateBedbankChangeDatesAccommodationCheckoutItems } from 'lib/checkout/accommodation/cart'
import { ISO_DATE_FORMAT } from '../constants/dateFormats'
import { createQuote, QuoteDedupeKeys, updateQuote } from 'api/cart'
import { getSubscriptionOffer } from 'api/luxPlus'
import { generatePassengersFromOccupants } from 'checkout/lib/utils/flights/passenger'
import { CHECKOUT_ITEM_TYPE_BEDBANK, CHECKOUT_ITEM_TYPE_LE_HOTEL } from 'constants/checkout'
import { FlightViewTypes } from 'constants/flight'
import CartInitError from 'errors/CartInitError'
import { generateFlightCheckoutItem } from 'lib/checkout/flights/cart'
import { generateLuxPlusSubscriptionItems } from 'lib/checkout/luxPlusSubscription/cart'
import getPackageFromOffer from 'lib/offer/getPackageFromOffer'
import { countOccupantsForFlights } from 'lib/offer/occupancyUtils'
import uuidV4 from 'lib/string/uuidV4Utils'
import { getIsLuxPlusEnabled } from 'luxPlus/selectors/featureToggle'
import { getAgentHubCommissionPromoCode } from 'agentHub/api/agentHubCalculateCartCommission'
import { stateToCommissionOrder } from 'agentHub/api/mappers/agentHubMap'
import { updateLESubscriptionsV2 } from './LESubscriptionsActions'
import * as Analytics from 'analytics/analytics'
import { Region } from 'constants/geo'
import { AppAction } from './types/ActionTypes'
import getDepositRemaining from 'checkout/selectors/payment/deposit/getDepositRemaining'
import { getChannelMarkup } from 'selectors/channelMarkupSelector'
import getCheckoutTravellerSchema from 'checkout/selectors/getCheckoutTravellerSchema'
import { getSource, getFullOffers } from 'selectors/offerSelectors'
import { applyPromoWithV2ItemTotals, checkoutStateToDiscountOrder, stateToDiscountOrder } from 'lib/promo/promoMappers'
import { addToUserCart, addUserCartConnectedRooms, createCustomerTravellerDetails, removeUserCartConnectedRoom, updateCustomerTravellerDetails, updateTravellerDetails, updateUserDetails, userCartItemsSaveForLater } from './AuthActions'
import { isUserCartSupportedItem } from 'lib/checkout/userCart'
import { isMultiCartEnabled } from 'selectors/featuresSelectors'
import { findPostPurchaseCheckout, isCarHireItem, isFlightItem } from 'lib/checkout/checkoutUtils'
import { resetFlightsTimer } from 'components/Flights/FlightsSessionTimer/FlightsSessionTimer'
import { getUserCartAbandonableItems } from 'selectors/userCart'
import { isPostPurchaseAncillaryPayment } from 'checkout/selectors/payment/isPostPurchaseAncillaryPayment'
import { SHOULD_AUTOBATCH } from '@reduxjs/toolkit'
import { magicLoyaltyTransferExperienceId, magicLoyaltyTransferExperienceTicketId } from 'loyalty/constants/loyaltyBenefitsConstants'
import getExperienceItems from 'checkout/selectors/view/getExperienceItems'
import getExperienceItemsView from 'checkout/selectors/view/getExperienceItemsView'
import { matchBedbankRateOrItem } from 'lib/hotels/bedbankUtils'
import { SubscriptionSource } from 'api/LESubscriptions'
import { removeUnknownTravellersAndFields } from 'lib/checkout/form'
import { getPrimaryTravellerForm } from 'selectors/checkoutSelectors'
import { selectSelectedTravellerEmployees } from 'businessTraveller/selectors/businessTravellerEmployeeSelectors'
import getLEBTTravellerForms from 'checkout/lib/utils/form/getLEBTTravellerForms'
import { applyAccommodationTripRequestDetailsToForms, applyFlightTripRequestDetailsToForms, hasAccommodationTripRequestToRestore, hasFlightTripRequestToRestore } from 'checkout/lib/utils/form/applyTripRequestDetailsToForms'
import { objectKeys, omitKeys } from 'lib/object/objectUtils'
import { saveCabinOptions } from './CruiseActions'
import { allocateTravellersToRooms } from 'businessTraveller/utils/allocateTravellersToRooms'

export interface CartInitialisationParams {
  regionCode: string;
  currencyCode: string;
  isGift: boolean;
  isRestoreCheckout: boolean;
  mode?: App.CheckoutCartMode;
  order?: App.Order;
  connectedRoomOfferIds?: Array<string>;
  isMultiCart: boolean;
  restoreCartDetails?: App.CheckoutRestoredCartState;
  approvalRequestId?: string;
}

export function initialiseCheckout(items: Array<App.Checkout.AnyItem>, params: Partial<CartInitialisationParams> = {}, initFromUserCart?: boolean): AppAction {
  return function(dispatch, getState) {
    const state = getState()
    const transformedParams: CartInitialisationParams = {
      regionCode: params.regionCode ?? state.geo.currentRegionCode,
      currencyCode: params.currencyCode ?? state.geo.currentCurrency,
      isGift: params.isGift ?? false,
      mode: params.mode,
      order: params.order,
      connectedRoomOfferIds: params.connectedRoomOfferIds,
      isMultiCart: !!initFromUserCart,
      restoreCartDetails: params.restoreCartDetails,
      approvalRequestId: params.approvalRequestId,
      isRestoreCheckout: false,
    }

    const isMultiItemCartActive = isMultiCartEnabled(state)
    const selectVertical = params.mode === 'vertical-select'
    if (isMultiItemCartActive && !initFromUserCart && !selectVertical && !findPostPurchaseCheckout(params.mode)) {
      // Flight items have an empty state in bundle flow so filter them initially
      const abandonableItems = getUserCartAbandonableItems(state, items).filter(item => {
        if (params.mode !== 'vertical-select') return item
        return !isFlightItem(item)
      })
      dispatch(addToUserCart(abandonableItems, true))
    }

    const flightItem = items.find(isFlightItem)
    if (flightItem?.expiry) {
      // TODO: Stop using a cookie for this
      resetFlightsTimer(flightItem.expiry)
    }

    const carHireItem = items.find(isCarHireItem)
    const hasApprovalContext = flightItem || carHireItem
    if (hasApprovalContext && state.checkout.cart.approvalRequestId) {
      transformedParams.approvalRequestId = state.checkout.cart.approvalRequestId
    }

    clearFormStateCheckout()
    clearFormStateSnapshot()

    dispatch({
      type: CHECKOUT_INITIALISE,
      items,
      params: transformedParams,
    })
  }
}

export function clearRestoreCartPrice(): AppAction {
  return {
    type: CHECKOUT_CLEAR_CART_RESTORE_PRICE,
  }
}

export function clearCheckoutCart(): AppAction {
  return {
    type: CHECKOUT_CLEAR_CART,
  }
}

export function restoreCheckoutCart(cartState: Partial<App.CheckoutCartState>): AppAction {
  return {
    type: CHECKOUT_RESTORE_CART,
    cartState,
  }
}

export function restoreCheckoutForm(formState: Partial<App.Checkout.FormState>): AppAction {
  return {
    type: CHECKOUT_RESTORE_FORM,
    formState,
  }
}

export function resetCheckoutForm(): AppAction {
  return {
    type: CHECKOUT_RESET_FORM,
  }
}

export function resetCheckoutCommission(): AppAction {
  return {
    type: CHECKOUT_RESET_COMMISSION,
  }
}

export function restoreCheckoutPayment(state: Partial<App.Checkout.PaymentState>): AppAction {
  return {
    type: CHECKOUT_RESTORE_PAYMENT,
    state,
  }
}

/**
 * Will update (more upsert) items.
 * Will update the item *in place* if it exists, otherwise, will put it at the end
 * @param item The item to update
 */
export function updateCheckoutItem(item: App.Checkout.AnyItem): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const selectVertical = state.checkout.cart.mode === 'vertical-select'
    dispatch({
      type: CHECKOUT_UPDATE_ITEM,
      item,
      meta: {
        [SHOULD_AUTOBATCH]: true,
      },
    })
    const isMultiItemCartActive = isMultiCartEnabled(state)
    if (!selectVertical && isMultiItemCartActive && isUserCartSupportedItem(item)) {
      dispatch(addToUserCart([item], true))
    }
  }
}

export function removeItem(itemId: string): AppAction {
  return (dispatch, getState) => {
    const state = getState()

    dispatch({
      type: CHECKOUT_REMOVE_ITEM,
      itemId,
      meta: {
        [SHOULD_AUTOBATCH]: true,
      },
    })

    const item = state.checkout.cart.items.find(item => item.itemId === itemId)

    if (item?.itemType === 'bedbankHotel') {
      dispatch(updateBedbankSession())
    }

    if (state.auth.userCart.items[itemId]) {
      dispatch(userCartItemsSaveForLater([itemId]))
    }
  }
}

export function removeItems(itemIds: Array<string>): AppAction {
  return (dispatch) => {
    itemIds.forEach((item) => {
      dispatch(removeItem(item))
    })
  }
}

export function addItem(item: App.Checkout.AnyItem): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const isMultiItemCartActive = isMultiCartEnabled(state)
    if (isMultiItemCartActive &&
      state.checkout.cart.mode !== 'vertical-select' &&
      isUserCartSupportedItem(item)
    ) {
      // Flight items have an empty state in bundle flow
      dispatch(addToUserCart([item], true))
    }
    dispatch({
      type: CHECKOUT_ADD_ITEM,
      item,
      meta: {
        [SHOULD_AUTOBATCH]: true,
      },
    })
  }
}

export function addItems(items: Array<App.Checkout.AnyItem>): AppAction {
  return (dispatch) => {
    items.forEach((item) => {
      dispatch(addItem(item))
    })
  }
}

export function addToCheckoutCart(items: Array<App.Checkout.AnyItem> | App.Checkout.AnyItem, initParams?: Partial<CartInitialisationParams>): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const arrayItems = Array.isArray(items) ? items : [items]
    if ((!state.checkout.cart.isMultiItemMode || state.checkout.cart.cartId === null) || !!initParams) {
      dispatch(initialiseCheckout(arrayItems, initParams))
    } else {
      arrayItems.forEach(item => dispatch(addItem(item)))
    }
  }
}

export function toggleMultiCartItemMode(): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const isMultiItemMode = state.checkout.cart.isMultiItemMode
    dispatch(clearCheckoutCart())
    dispatch({
      type: CHECKOUT_SET_MULTI_CART_ITEM_MODE,
      isMultiItemMode: !isMultiItemMode,
    })
  }
}

export function setSpecialRequest(itemId: string, request: string): AppAction {
  return {
    type: CHECKOUT_SET_SPECIAL_REQUEST,
    itemId,
    request,
  }
}

export function addRoomsToBeConnected(offerId: string): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    dispatch({
      type: CHECKOUT_ADD_ROOMS_TO_BE_CONNECTED,
      offerId,
    })
    const isMultiItemCartActive = isMultiCartEnabled(state)
    if (isMultiItemCartActive) {
      dispatch(addUserCartConnectedRooms(offerId))
    }
  }
}

export function removeRoomsToBeConnected(offerId: string): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    dispatch({
      type: CHECKOUT_REMOVE_ROOMS_TO_BE_CONNECTED,
      offerId,
    })
    const isMultiItemCartActive = isMultiCartEnabled(state)
    if (isMultiItemCartActive) {
      dispatch(removeUserCartConnectedRoom(offerId))
    }
  }
}

export function processingStart(): AppAction {
  return {
    type: CHECKOUT_PROCESS_START,
  }
}

export function processingSuccess(): AppAction {
  return {
    type: CHECKOUT_PROCESS_SUCCESS,
  }
}

export function processingCancel(): AppAction {
  return {
    type: CHECKOUT_PROCESS_CANCEL,
  }
}

export function processingFailure(name: string, status?: number, errorMsg?: string): AppAction {
  return {
    type: CHECKOUT_PROCESS_FAILURE,
    data: {
      name,
      status,
      errorMsg,
    },
  }
}

function resetPaymentSelectionBeforeCreditApplied(dispatch: AppDispatch, state: App.State) {
  const creditPayableAmount = getCreditPayableAmount(state)
  const depositBalance = getDepositRemaining(state)

  // before credit is applied check if selected payment option is deposit and whether credit amount is greater than deposit balance
  if (!state.checkout.payment.useCredit && state.checkout.payment.paymentSelected === PAYMENT_OPTIONS.DEPOSIT &&
    creditPayableAmount >= depositBalance) {
    dispatch(updatePaymentSelection(PAYMENT_OPTIONS.FULL))
  }
}

export function toggleCredit(): AppAction {
  return (dispatch, getState) => {
    const state = getState()

    resetPaymentSelectionBeforeCreditApplied(dispatch, state)

    dispatch({
      type: CHECKOUT_TOGGLE_CREDIT,
    })
  }
}

export function setUsingCredit(useCredit: boolean): AppAction {
  return (dispatch, getState) => {
    const state = getState()

    if (state.checkout.payment.useCredit === useCredit) {
      // it's already set
      return
    }

    resetPaymentSelectionBeforeCreditApplied(dispatch, state)

    dispatch({
      type: CHECKOUT_TOGGLE_CREDIT,
      useCredit,
    })
  }
}

export function toggleGiftCard(): AppAction {
  return (dispatch) => {
    dispatch({
      type: CHECKOUT_TOGGLE_GIFT_CARD,
    })
  }
}

export function setUsingGiftCard(useGiftCard: boolean): AppAction {
  return (dispatch, getState) => {
    const state = getState()

    if (state.checkout.payment.useGiftCard === useGiftCard) {
      // it's already set
      return
    }

    dispatch({
      type: CHECKOUT_TOGGLE_GIFT_CARD,
      useGiftCard,
    })
  }
}

export function applyVelocityBurn(points: number): AppAction {
  return {
    type: CHECKOUT_APPLY_VELOCITY_BURN,
    points,
  }
}

export function setPartnershipStatus(
  partnership: 'velocity',
  status: boolean,
): AppAction {
  return {
    type: CHECKOUT_APPLY_PARTNERSHIP_STATUS,
    partnership,
    status,
  }
}

export function setVelocityBurnModalStatus(isActive: boolean, isClean = false): AppAction {
  const data = { isActive, isClean }
  return {
    type: CHECKOUT_SET_VELOCITY_BURN_MODAL_STATUS,
    data,
  }
}

export function getVelocityMemberDetails(token: string) {
  return {
    type: API_CALL,
    api: FETCH_VELOCITY_MEMBER_DETAILS,
    request: async() => {
      const memberProfile = await getVelocityMemberProfile(token)
      if (memberProfile.pointBalance < VIRGIN_VELOCITY_BURN_MINIMUM) {
        showSnackbar(
          'Sorry! Your Velocity point balance is insufficient for payment',
          'critical',
        )
      }
      return memberProfile
    },
  }
}

export function saveVelocitySSO(data: Partial<App.Checkout.VelocitySSO>): AppAction {
  return {
    type: CHECKOUT_SET_VELOCITY_SSO,
    data,
  }
}

export function fetchTravellerFormSchema(): AppAction {
  return (dispatch, getState) => {
    const state = getState()

    const key = getTravellerFormSchemaRequestKey(state)
    if (
      state.checkout.schemaData[key] ||
      state.checkout.fetchingSchemaData[key] ||
      state.checkout.schemaDataErrors[key]
    ) {
      // already processing it
      return
    }

    const requestPayload = getTravellerFormSchemaRequest(state)

    if (requestPayload.items.length > 0) {
      dispatch({
        type: API_CALL,
        api: FETCH_TRAVELLER_FORM_SCHEMA,
        schemaRequestData: requestPayload,
        request: () => retrieveTravellerDetailsForm(requestPayload).then(mapHotelLoyaltyProgramTitle),
        key,
        isDevMode: state.checkout.cart.isDevToolsEnabled,
      })
    } else {
      dispatch({
        type: API_CALL,
        api: FETCH_TRAVELLER_FORM_SCHEMA,
        schemaRequestData: requestPayload,
        request: () => Promise.resolve(null),
        key,
        isDevMode: state.checkout.cart.isDevToolsEnabled,
      })
    }
  }
}

export function removeTravellerSchema(): AppAction {
  return { type: CHECKOUT_REMOVE_TRAVELLER_SCHEMA }
}

export function setTravellerForm(form: App.Checkout.FormState): AppAction {
  return {
    type: CHECKOUT_SET_FORM,
    form,
  }
}

export function clearTravellerForm(travellerId: string): AppAction {
  return {
    type: CHECKOUT_CLEAR_TRAVELLER_FORM,
    travellerId,
  }
}

export function setTravellerFormInitStatus(status: App.Checkout.TravellerFormInitStatus): AppAction {
  return {
    type: CHECKOUT_SET_TRAVELLER_FORM_INIT_STATUS,
    status,
  }
}

function travellerDetailsToCompanionPayload(traveller: App.Checkout.TravellerForm): Omit<App.TravelCompanion, 'id'> {
  return {
    title: traveller.data.title as App.Title,
    firstName: traveller.data.firstName,
    middleName: traveller.data.middleName,
    lastName: traveller.data.lastName,
    dateOfBirth: traveller.data.dateOfBirth,
    countryOfResidence: traveller.data.countryOfResidence,
    phone: traveller.data.phonePrefix && traveller.data.phone ? `${traveller.data.phonePrefix}${traveller.data.phone}` : undefined,
    email: traveller.data.email,
  }
}

export function saveTravellerForm(
  travellerData: App.Checkout.TravellerForm,
  options: {
    /**
     * If true, saving a new traveller with `saveDetails: true` will cause the companion to be created immediately,
     * rather than when the purchase is completed.
     */
    createCompanionImmediately: boolean,
  } = { createCompanionImmediately: false },
): AppAction {
  return function(dispatch, getState) {
    const state = getState()

    const schema = getCheckoutTravellerSchema(state)?.accommodationFlightSchema
    if (!schema) { return }

    const { form } = state.checkout

    // The data is being deliberately saved, so it's no longer tentative prefill data
    const traveller = omitKeys(['isTentativePrefilled'], travellerData)

    const newTravellerFormList = sortTravellers([...form.travellerForms.filter(x => x.id !== traveller.id), traveller])

    const newFormState = { ...form, travellerForms: newTravellerFormList }

    if (!equal(form, newFormState)) {
      dispatch(setTravellerForm(newFormState))

      // For cruise, invalidate the pricing data for the item if any details have changed
      const relatedItem = schema.properties[traveller.id].relatedItem
      if (relatedItem?.type === 'cruise' && relatedItem.id) {
        dispatch(saveCabinOptions(relatedItem.id))
      }
    }

    if (traveller.type === 'new' && traveller.saveDetails && options.createCompanionImmediately) {
      const companionData = travellerDetailsToCompanionPayload(traveller)
      dispatch(createCustomerTravellerDetails(companionData, {
        onCreated: companion => {
          const formState = getState().checkout.form
          dispatch(setTravellerForm({
            ...formState,
            travellerForms: formState.travellerForms.map(t => {
              if (t.id === traveller.id) {
                return {
                  ...t,
                  type: 'companion',
                  travellerOptionKey: `companion-${companion.id}`,
                  data: t.data,
                  companionId: companion.id,
                  saveDetails: false,
                }
              } else {
                return t
              }
            }),
          }))
        },
      }))
    }
  }
}

export function saveTravellerDataFromForms(): AppAction {
  return function(dispatch, getState) {
    const state = getState()
    const travellerForms = state.checkout.form.travellerForms
    const primaryTravellerForm = getPrimaryTravellerForm(state)
    const account = state.auth.account
    let didUpdateAccountHolder = false

    travellerForms.forEach((traveller) => {
      if (!traveller.saveDetails) {
        return
      }

      if (traveller.type === 'new') {
        dispatch(createCustomerTravellerDetails(travellerDetailsToCompanionPayload(traveller)))
      } else if (traveller.type === 'companion' && traveller.companionId) {
        dispatch(updateCustomerTravellerDetails({
          id: traveller.companionId,
          ...travellerDetailsToCompanionPayload(traveller),
        }))
      } else if (traveller.type === 'account-holder') {
        dispatch(updateUserTravellerDetails(traveller))
        didUpdateAccountHolder = true
      }
    })

    if (
      !didUpdateAccountHolder &&
      (primaryTravellerForm?.data.phone && primaryTravellerForm?.data.phonePrefix) &&
      !account.phone
    ) {
      // update accounts phone number from the primary traveller if the account doesn't have one
      dispatch(updateUserDetails({
        phone: primaryTravellerForm.data.phone,
        phonePrefix: primaryTravellerForm.data.phonePrefix,
      }))
    }
  }
}

export function cleanTravellerFormData(formSchema: App.Checkout.FormSchema): AppAction {
  return function(dispatch, getState) {
    const state = getState()

    const travellerForms = state.checkout.form.travellerForms

    if (travellerForms.length > 0) {
      // Have existing data - make sure there's no remaining data from previous schema that doesn't fit this one
      const cleanedForms = removeUnknownTravellersAndFields(formSchema, travellerForms)
      if (!equal(travellerForms, cleanedForms)) {
        dispatch(setTravellerForm({
          ...state.checkout.form,
          travellerForms: cleanedForms,
        }))
      }
    }
  }
}

export function initialiseLEBTTravellerFormData(formSchema: App.Checkout.FormSchema, isLEBTBookingForSelf: boolean): AppAction {
  return function(dispatch, getState) {
    const state = getState()

    const travellerForms = state.checkout.form.travellerForms

    if (travellerForms.length > 0) {
      // We only want to do this if the forms haven't already been initialised
      return
    }

    const schemaTravellerIds = Object.keys(formSchema.properties)
    const schemaTravellerIdsSet = new Set(schemaTravellerIds)

    // Function to get full offer details by offer ID
    const getOffer = (offerId: string) => getFullOffers(state)[offerId]

    const accommodationItems = state.checkout.cart.items.filter((item) =>
      item.itemType === 'hotel' || item.itemType === 'bedbankHotel'
    ) as Array<App.Checkout.LEHotelItem | App.Checkout.BedbankHotelItem>

    const travellerEmployees = selectSelectedTravellerEmployees(state)

    const baseForms = getLEBTTravellerForms({
      isLEBTBookingForSelf,
      travellerEmployees,
      travellerGuestIds: state.businessTraveller.selectedTravellerGuestIds ?? [],
      selectedEmployeeDetails: state.businessTraveller.employeeDetails.all,
      account: state.auth.account,
      currentRegionCode: state.geo.currentRegionCode,
      businessAccount: state.businessTraveller.currentBusinessAccount,
      currentTravellerForms: state.checkout.form.travellerForms,
      isGift: state.checkout.cart.isGift,
      flightItems: state.checkout.cart.items.filter((item) => item.itemType === 'flight'),
      accommodationItems,
      getOffer,
    })

    // Apply trip request details based on trip request type
    let forms = baseForms
    if (hasAccommodationTripRequestToRestore()) {
      // Restore room assignment and traveller details from the trip request
      forms = applyAccommodationTripRequestDetailsToForms(baseForms)
    } else if (hasFlightTripRequestToRestore(state)) {
      forms = applyFlightTripRequestDetailsToForms(baseForms, state, formSchema)
    }

    // Assign traveller IDs to forms
    const formIds = forms.map(f => f.id).filter(id => id)
    const remainingIdsIterator = without(schemaTravellerIds, ...formIds).values()

    const formsWithIds = nonNullable(forms.map(form => {
      if (schemaTravellerIdsSet.has(form.id)) {
        return form
      } else {
        const nextId = remainingIdsIterator.next()
        if (nextId.done) {
          return undefined
        }
        return {
          ...form,
          id: nextId.value,
        }
      }
    }))

    const cleanedForms = removeUnknownTravellersAndFields(formSchema, formsWithIds)
    dispatch(setTravellerForm({
      ...state.checkout.form,
      travellerForms: cleanedForms,
    }))
  }
}

export function respondShadowBanUserError(paymentType: string): AppAction {
  return function(dispatch, getState) {
    const state = getState()

    if (!state.checkout.processing) {
      dispatch(processingStart())
    }

    let responseMsg: string
    switch (paymentType) {
      case CREDIT_PAYMENT_TYPE:
      case PROMO_PAYMENT_TYPE:
        responseMsg = 'An error occurred while processing your card'
        break
      case STRIPE_PAYMENT_TYPE:
        responseMsg = 'Your card was declined. Decline Code: [1]'
        break
      default:
        responseMsg = 'Default Error Message'
    }

    setTimeout(() => {
      dispatch(processingFailure(responseMsg, 400))
      dispatch(genericOrderErrorModalOpen([responseMsg]))
    }, 3000)
  }
}

export function updateUserTravellerDetails(details: App.Checkout.TravellerForm): AppAction {
  return function(dispatch, getState) {
    const state = getState()
    const account = state.auth.account
    const customerId = account.memberId

    if (!customerId) { return }

    const accountUpdate: Partial<App.AuthAccount> = {}

    if (details.data.firstName && !account.givenName) {
      accountUpdate.givenName = details.data.firstName
    }
    if (details.data.middleName && !account.middleName) {
      accountUpdate.middleName = details.data.middleName
    }
    if (details.data.lastName && !account.surname) {
      accountUpdate.surname = details.data.lastName
    }
    if (
      details.data.phone && details.data.phonePrefix &&
      // Only update phone number if they don't already have one, because we have a
      // confirmation process for changing the phone number on the account.
      !account.phone
    ) {
      accountUpdate.phone = details.data.phone
      accountUpdate.phonePrefix = details.data.phonePrefix
    }

    if (details.data.dateOfBirth) {
      accountUpdate.dob = details.data.dateOfBirth
    }
    if (details.data.postcode) {
      accountUpdate.postcode = details.data.postcode
    }

    if (objectKeys(accountUpdate).length > 0) {
      dispatch(updateUserDetails(accountUpdate))
    }

    dispatch(updateTravellerDetails({
      customerId,
      title: details.data.title as App.Title,
      gender: deduceGenderFromTitle(details.data.title as App.Title),
      middleName: details.data.middleName,
      addressDetails: {
        address: details.data.address,
        city: details.data.city,
        state: details.data.state,
        usStateOfResidence: details.data.usStateOfResidence,
        countryOfResidence: details.data.countryOfResidence,
        postcode: details.data.postcode,
      },
    }))
  }
}

export function updatePaymentSelection(paymentSelected: PAYMENT_OPTIONS): AppAction {
  return {
    type: CHECKOUT_UPDATE_PAYMENT_SELECTION,
    paymentSelected,
  }
}

export function updateExperienceItem(
  experienceId: string,
  data: { details?: ExperienceDetails, tickets?: Array<App.Checkout.ExperienceItemTicket> }): AppAction {
  return {
    type: CHECKOUT_UPDATE_EXPERIENCE_ITEM,
    id: experienceId,
    data,
  }
}

export function removeUnpurchasableItems(): AppAction {
  return function(dispatch, getState) {
    const state = getState()

    // Remove unpurchasable experience tickets
    const experienceItems = getExperienceItems(state)
    const expItemViewsById = arrayToMap(getExperienceItemsView(state).data.filter(Boolean), v => v.item.itemId)
    experienceItems.forEach(item => {
      const itemView = expItemViewsById.get(item.itemId)
      if (!itemView) { return }
      const unavailableTicketIds = new Set(itemView.ticketViews.filter(v => v.unavailable).map(v => v.ticket.id))

      const availableTickets = item.tickets.filter(t => !unavailableTicketIds.has(t.ticketId))

      if (availableTickets.length === 0) {
        dispatch(removeItem(item.itemId))
      }
      else if (availableTickets.length < item.tickets.length) {
        dispatch(updateExperienceItem(item.experienceId, { tickets: availableTickets }))
      }
    })
  }
}
export function setLuxPlusUpsellData(
  params: SnowplowEvent,
): AppAction {
  return {
    type: CHECKOUT_SET_LUXPLUS_UPSELL_DATA,
    eventData: params,
  }
}

/**
 * @deprecated Set these values in the initial `intialiseCheckout` instead
 */
export function setPostPurchaseOrder(order: App.Order, mode: App.CheckoutPostPurchaseMode): AppAction {
  return {
    type: CHECKOUT_SET_POST_PURCHASE,
    order,
    mode,
  }
}

export function showCorporateBenefitsForm(promoCode: string, corporateName: string, allowedEmailDomains: Array<string>): AppAction {
  return {
    type: CHECKOUT_SHOW_PROMO_CORPORATE_BENEFITS,
    promoCode,
    corporateName,
    allowedEmailDomains,
  }
}

export function hideCorporateBenefitsForm(): AppAction {
  return {
    type: CHECKOUT_HIDE_PROMO_CORPORATE_BENEFITS,
  }
}

export function showFriendsAndFamilyForm(promoCode: string, category: string): AppAction {
  return {
    type: CHECKOUT_SHOW_PROMO_FRIENDS_AND_FAMILY,
    promoCode,
    category,
  }
}

export function hideFriendsAndFamilyForm(): AppAction {
  return {
    type: CHECKOUT_HIDE_PROMO_FRIENDS_AND_FAMILY,
  }
}

export function requestCorporateBenefitsPromo(corporateEmail: string): AppAction {
  return async function(dispatch, getState) {
    const state = getState()

    dispatch({
      type: API_CALL,
      api: CHECKOUT_REQUEST_CORPORATE_BENEFITS_PROMO,
      submittedEmail: corporateEmail,
      request: () => registerCorporateBenefits(
        state.checkout.corporatePromoForm.sourceCodeName as string,
        corporateEmail,
      ),
    })
  }
}

export function requestFriendsAndFamilyPromo(data: Omit<RestrictedPromoRequestData, 'code' | 'category'>): AppAction {
  return async function(dispatch, getState) {
    const state = getState()

    dispatch({
      type: API_CALL,
      api: CHECKOUT_REQUEST_FRIENDS_AND_FAMILY_PROMO,
      submittedEmail: data.email,
      request: () => registerFriendsAndFamily({
        ...data,
        code: state.checkout.friendsAndFamilyPromoForm.sourceCodeName!,
        category: state.checkout.friendsAndFamilyPromoForm.category!,
      }),
    })
  }
}

export function applyCommissionPromoCode(code: string): AppAction {
  return (dispatch, getState) => {
    const state = getState()

    const applyWitItemTotalsV2 = applyPromoWithV2ItemTotals(state)
    const discountRequestOrder = checkoutStateToDiscountOrder(state, !applyWitItemTotalsV2)
    const discountRequestOrderV2 = stateToDiscountOrder(state)

    dispatch({
      type: API_CALL,
      api: FETCH_COMMMISSION_PROMO,
      request: () => getPromoV2({
        codeName: code,
        order: applyWitItemTotalsV2 ? discountRequestOrderV2 : discountRequestOrder,
        preCheckoutOrder: applyWitItemTotalsV2 ? discountRequestOrder : discountRequestOrderV2,
        userId: state.auth.account.memberId as string,
        requestSource: 'global-checkout',
      }),
    })
  }
}

function isPromotion(referral: App.Promotion | App.ReferralError): referral is App.Promotion {
  return 'code' in referral && 'id' in referral
}

/**
 * MARKETING_SERVER_SIDE_PROMO_CHECKOUT_CALC_ENABLED:
 * 0 - the promo calculation occurs below (legacy) or within svc-promo
 * 1 - the promo calculation occurs within svc-promo and is returned via promo.discountTotal
 *
 */
export function addPromoCode(codeName: string): AppAction {
  return async function(dispatch, getState) {
    try {
      dispatch({
        type: CHECKOUT_FETCHING_PROMO_CODE,
      })

      const state = getState()
      let referralResult: App.Promotion | App.ReferralError | undefined

      if (couldBeReferralCode(codeName)) {
        referralResult = await getReferralPromotion(state, codeName)
        if (referralResult && !isPromotion(referralResult)) {
          dispatch({
            type: CHECKOUT_APPLY_PROMO_CODE_FAILED,
            error: referralResult.message ?? 'Failed to apply referral code',
          })
          return
        }
      }
      const usePromoItemTotalsV2 = applyPromoWithV2ItemTotals(state)
      const discountRequestOrder = checkoutStateToDiscountOrder(state, !usePromoItemTotalsV2)
      const discountRequestOrderV2 = stateToDiscountOrder(state)

      let codeNameLookup = codeName
      if (referralResult && isPromotion(referralResult)) {
        codeNameLookup = referralResult.code
      }
      const promotion = await getPromoV2({
        codeName: codeNameLookup,
        order: usePromoItemTotalsV2 ? discountRequestOrderV2 : discountRequestOrder,
        preCheckoutOrder: usePromoItemTotalsV2 ? discountRequestOrder : discountRequestOrderV2,
        userId: state.auth.account.memberId as string,
        requestSource: 'global-checkout',
      })

      if (promotion) {
        verifyPromotion(promotion, state)
        applyPromotion(promotion, dispatch)
      }
    } catch(e) {
      if (e.status === 422) {
        const messageCode = e.result?.message

        if (messageCode === 'corporateEmailRequired') {
          dispatch(showCorporateBenefitsForm(codeName, e.metadata?.corporateName, e.metadata?.allowedEmailDomains))
        }
        else if (messageCode === 'restrictedCategory') {
          // todo: rename it to more appropriate name
          // when more categories is added
          dispatch(showFriendsAndFamilyForm(codeName, e.metadata?.category))
        }
      } else {
        dispatch({
          type: CHECKOUT_APPLY_PROMO_CODE_FAILED,
          error: e.result?.errors.length > 0 ? e.result.errors[0].message : e.message,
        })
      }
    }
  }
}

async function getReferralPromotion(state: App.State, codeName: string): Promise<App.Promotion | App.ReferralError | undefined> {
  const regionCode = state.geo.currentRegionCode
  const { data } = getCheckoutTotalsView(state)
  const itemTypes = state.checkout.cart.items.map((i) => i.itemType)
  const payableTotal = data.subTotal + data.taxesAndFees

  if (couldBeReferralCode(codeName)) {
    return getReferralPromo({
      codeName,
      regionCode,
      brand: config.BRAND,
      cartValue: payableTotal,
      itemTypes,
    })
  }
  return
}

function couldBeReferralCode(codeName: string): boolean {
  return codeName.slice(0, 6).includes('INVITE')
}

/**
 * @deprecated - These checks are moving into svc-promo via the /api/promo/discount endpoint
 */
function verifyPromotion(
  promotion: App.Promotion,
  state: App.State,
) {
  verifyPromoPayMethods(promotion, state)
  verifyPromoOnAirlineCarriers(promotion, state)
}

function verifyPromoPayMethods(promotion: App.Promotion, state: App.State) {
  const paymentMethodAvailability = getPaymentMethodAvailability(state)
  if (
    promotion.allowedPaymentMethods.length > 0 &&
    promotion.allowedPaymentMethods.every((paymentMethod: PaymentMethod) => !paymentMethodAvailability[paymentMethod])
  ) {
    throw new Error('Invalid promo code for this deal')
  }
}

export function verifyPromoOnAirlineCarriers(promotion: App.Promotion, state: App.State) {
  if (!promotion.allowedAirlineCarriers?.length) {
    return
  }
  if (promotion.type !== 'fixed_amount') {
    throw new Error('Promo code cannot be applied')
  }
  const journeys = getCartFlightJourneys(state)
  const allowedAirlineCarriers = new Set(promotion.allowedAirlineCarriers)
  const anyAirlineCarrierMatches = journeys.some(journey => {
    return journey.departing.flights.some((flight) => allowedAirlineCarriers.has(flight.carrier)) ||
      journey.returning?.flights.some((flight) => allowedAirlineCarriers.has(flight.carrier))
  })
  if (!anyAirlineCarrierMatches) {
    throw new Error('Promo code cannot be applied to selected airline')
  }
}

function applyPromotion(promotion: App.Promotion, dispatch: Dispatch) {
  dispatch({
    type: CHECKOUT_APPLY_PROMO_CODE,
    promotion,
  })
  dispatch({
    type: CHECKOUT_CLEAR_VELOCITY_BURN,
  })
  if (promotion.allowedPaymentMethods.length) {
    showSnackbar(
      paymentMethodsToString(promotion.allowedPaymentMethods),
      'success',
      { heading: 'Promo code applied' },
    )
  }
}

export function resetPromoCode(): AppAction {
  return {
    type: CHECKOUT_RESET_PROMO_CODE,
  }
}

export function setRestoreCartStatus(
  status: App.CheckoutState['restoreCart']['status'],
  options?: {
    errorMsg?: string,
    context?: App.RestoreCartErrorModalContext,
    restoredCartId?: string,
  },
): AppAction {
  return {
    type: CHECKOUT_SET_RESTORE_CART_STATUS,
    data: {
      status,
      ...options,
    },
  }
}

export function setCheckoutModifyFlightSearchView(view: App.CheckoutState['modifyFlightView']): AppAction {
  return {
    type: CHECKOUT_MODIFY_FLIGHT_SEARCH_VIEW,
    modifyFlightView: view,
  }
}

export async function initBedbankSession(
  dispatch: AppDispatch,
  payload: CreateReservationEnquiryProps,
): Promise<Bedbank.CreateReservationEnquiryResponse | { price?: number, propertyFees?: number }> {
  try {
    const session = await enquiry(payload)
    dispatch(setBedbankEnquiry(session))
    return session
  } catch(error) {
    if (error.status === 422) {
      const priceChange = error.errors?.find((e: { code: string }) => e.code === 'price_change')
      if (priceChange) {
        return {
          price: priceChange.price,
          propertyFees: priceChange.propertyFees,
        }
      }
    }
    throw error
  }
}

export function updateBedbankSession(): AppAction {
  return async function(dispatch, getState) {
    const state = getState()
    const viewsWithStatus = checkoutAccommodationOfferView(state)
    const source = getSource(state)

    for (const targetView of viewsWithStatus.data) {
      if (targetView.offerType !== OFFER_TYPE_BED_BANK) {
        continue
      }

      if (!targetView.offerLoaded || !targetView.bedGroups.length) {
        continue
      }

      const groupedBySessionId = groupBy(targetView.itemViews, itemView => itemView.item.sessionId)

      for (const itemViews of Array.from(groupedBySessionId.values())) {
        const targetItem = itemViews[0].item
        const accomTotals = sum(itemViews.map((itemView) => itemView.totals.price))
        const propertyFees = sum(itemViews.map((itemView) => itemView.totals.otherFees?.propertyFees ?? 0))

        // For multi-room bookings, 1 room = 1 order item = 1 session
        // Only include the occupancy for rooms in this session, not all rooms
        const sessionRoomsOccupancy = itemViews.map((itemView) => itemView.item.occupancy)

        const enquiryParams = {
          propertyId: targetView.offerId,
          isFlightBundle: targetItem.isFlightBundle,
          rooms: sessionRoomsOccupancy,
          roomTypeId: targetItem.roomId,
          roomRateId: targetItem.roomRateId,
          bedGroupId: targetItem.bedGroupId,
          rateGroupId: targetItem.rateGroupId,
          region: state.geo.currentRegionCode,
          checkIn: targetView.startDate,
          checkOut: targetView.endDate,
          price: accomTotals,
          csBooking: state.auth.account.isSpoofed,
          ...(propertyFees > 0 && { propertyFees }),
          source,
        }

        dispatch({
          type: API_CALL,
          api: UPDATE_BEDBANK_SESSION,
          request: async() => initBedbankSession(dispatch, enquiryParams)
            .then(response => {
              if (!('sessionId' in response)) {
                dispatch(bedbankHotelPriceChangeModalOpen({
                  newPrice: response.price ?? accomTotals,
                  oldPrice: accomTotals,
                  ...(response.propertyFees === undefined ? undefined : { newPropertyFees: response.propertyFees }),
                }))
                throw new Error(`Price is changed, new price is ${response.price}`)
              }
              return { sessionId: response.sessionId, oldSessionId: targetItem.sessionId }
            }),
          sessionId: targetItem.sessionId,
        })
      }
    }
  }
}

export function updateHotelItemPricing(itemId: string, newPrice: number, surcharge?: { newSurcharge?: number, newExtraGuestSurcharge?: number }): AppAction {
  return {
    type: CHECKOUT_UPDATE_HOTEL_ITEM_PRICING,
    itemId,
    newPrice,
    surcharge,
  }
}

export function updateBundleItemPricing(itemId: string, offerId: string, newPrice: number, surcharge?: { newSurcharge?: number, newExtraGuestSurcharge?: number }): AppAction {
  return {
    type: CHECKOUT_UPDATE_BUNDLE_ITEM_PRICING,
    itemId,
    offerId,
    newPrice,
    surcharge,
  }
}

export function toggleCheckoutDevMode(): AppAction {
  return {
    type: CHECKOUT_TOGGLE_DEV_TOOLS,
  }
}

export function toggleCheckoutLoyaltyEnrolment(): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const enrolLoyalty = state.checkout.loyalty.enrolCustomerAtCheckout
    dispatch({
      type: CHECKOUT_TOGGLE_LOYALTY_SIGNUP,
      enrolLoyalty: !enrolLoyalty,
    })
  }
}

export function setBedbankEnquiry(session: App.BedbankEnquiry): AppAction {
  return {
    type: SET_BEDBANK_SESSION,
    data: session,
  }
}

export function fetchBedbankEnquiry(sessionId: string): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const sessions = state.checkout.sessions

    if (sessionId && typeof sessions[sessionId] === 'undefined') {
      dispatch({
        type: API_CALL,
        api: FETCH_BEDBANK_SESSION,
        request: async() => getEnquiry(sessionId),
        sessionId,
      })
    }
  }
}

export function checkoutFetchAndInitialiseBedbankChangeDates(orderId: string, orderItemId: string): AppAction {
  return (dispatch) => {
    dispatch({
      type: API_CALL,
      api: CHECKOUT_FETCH_BEDBANK_EXISTING_ORDER,
      request: async() => {
        const order = await getFullOrder(orderId)
        const orderItem = order.bedbankItems.find(i => i.id === orderItemId)

        if (orderItem) {
          const offerId = orderItem.offer.id
          const offer = await getOfferById(offerId, {
            region: order.regionCode,
          }) as App.BedbankOffer

          dispatch({
            type: API_CALL_SUCCESS,
            api: FETCH_BEDBANK_OFFER,
            data: offer,
            offerId,
          })

          const bedGroupId = orderItem.rooms[0]?.bedGroup.id
          const isFlightBundle = orderItem.rooms[0]?.isFlightBundle
          const occupancies = orderItem.rooms?.filter(room => room.status === 'booked').map(room => room.occupancy)
          const dates = {
            checkIn: moment(orderItem.checkIn).format(ISO_DATE_FORMAT),
            checkOut: moment(orderItem.checkOut).format(ISO_DATE_FORMAT),
            duration: orderItem.duration,
          }

          const items = generateBedbankChangeDatesAccommodationCheckoutItems({
            orderId: order.id,
            orderItemId: orderItem.id,
            offerId: orderItem.offer.id,
            roomId: orderItem.roomTypeId,
            roomRateId: orderItem.roomRateId,
            isFlightBundle,
            bedGroupId,
            dates,
            occupancies,
          })

          dispatch(addToCheckoutCart([...items], {
            regionCode: order.regionCode,
            currencyCode: order.currencyCode,
            order,
            mode: 'change-dates',
          }))
        }
      },
    })
  }
}

export function initCheckoutBedbankChangeDatesSession(region: string, items: Array<App.Checkout.BedbankHotelItem>, isSpoofed: boolean): AppAction {
  return (dispatch) => {
    dispatch({
      type: API_CALL,
      api: CHECKOUT_INIT_BEDBANK_CHANGE_DATES_SESSION,
      request: async() => {
        const offerId = items[0].offerId
        const offer = await getOfferById(offerId, {
          region,
        }) as App.BedbankOffer

        const occupancy = items.map(item => item.occupancy)

        if (offer) {
          const updatedRatesRequest = {
            checkIn: items[0].checkIn,
            checkOut: items[0].checkOut,
            rooms: occupancy,
            region,
            isSpoofed,
          }

          const newRates = await getRatesForBedbankOffers([offer.id], updatedRatesRequest)
          const rate = newRates[0].rates.find(rate => rate.id === items[0].roomRateId)

          if (rate) {
            dispatch({
              type: API_CALL_SUCCESS,
              api: FETCH_BEDBANK_OFFERS_RATES,
              data: newRates,
              offerIds: [offer.id],
              filterKey: getBedbankRateKey(occupancy, items[0].checkIn, items[0].checkOut),
            })

            const session = await initBedbankSession(dispatch, {
              propertyId: offer.id,
              roomTypeId: items[0].roomId,
              roomRateId: rate.id,
              rateGroupId: rate.groupId,
              isFlightBundle: items[0].isFlightBundle,
              region,
              rooms: occupancy,
              checkIn: items[0].checkIn,
              checkOut: items[0].checkOut,
              price: rate.totals.inclusive,
              memberInclusive: rate.totals.memberInclusive,
              csBooking: isSpoofed,
            })

            if (!('sessionId' in session)) {
              throw new Error(`Price is changed in initCheckoutBedbankChangeDatesSession, inclusive price is ${rate.totals.inclusive}, exclusive price is ${rate.totals.exclusive} and total price is ${rate.totals.total}`)
            }

            for (const item of items) {
              dispatch(updateCheckoutItem({
                ...item,
                sessionId: session.sessionId,
                bedGroupId: session.bedGroupId,
              }))
            }
            return {
              sessionId: session.sessionId,
              defaultBedGroupId: session.bedGroupId,
            }
          } else {
            throw new Error('Room rate unavailable')
          }
        }
      },
    })
  }
}

export function getBedbankSessionGroupingKey(item: App.Checkout.BedbankHotelItem) {
  return `${item.offerId};${item.roomId};${item.roomRateId};${item.checkIn};${item.checkOut}`
}

export async function initCheckoutBedbankSession(
  dispatch: AppDispatch,
  state: App.State,
  region: string,
  itemGroup: Array<App.Checkout.BedbankHotelItem>,
  isSpoofed: boolean,
): Promise<{
  sessionId: string,
  defaultBedGroupId: string,
  roomRateId: string,
}> {
  const item = itemGroup[0]
  const offerId = itemGroup[0].offerId
  const checkIn = itemGroup[0].checkIn
  const checkOut = itemGroup[0].checkOut
  const roomId = itemGroup[0].roomId
  const roomRateId = itemGroup[0].roomRateId
  const isFlightBundle = itemGroup[0].isFlightBundle
  const key = getBedbankSessionGroupingKey(itemGroup[0])
  const occupancies = itemGroup.map(item => item.occupancy)

  if (itemGroup.some(item => getBedbankSessionGroupingKey(item) !== key)) {
    throw new Error('Invalid items')
  }

  const offer = await getOfferById(offerId, {
    region,
  }) as App.BedbankOffer

  dispatch({
    type: API_CALL_SUCCESS,
    api: FETCH_BEDBANK_OFFER,
    data: offer,
    offerId,
  })

  if (offer) {
    const updatedRatesRequest = {
      checkIn,
      checkOut,
      rooms: occupancies,
      region,
      isSpoofed,
    }

    const newRates = await getRatesForBedbankOffers([offer.id], updatedRatesRequest)
    // Rate ID is not unique flight bundle rates appear twice
    const rates = newRates?.[0]?.rates
    let rate = rates?.find(rate => rate.id === roomRateId && rate.isFlightBundle === isFlightBundle)
    if (!rate) {
      rate = rates?.find(rate => matchBedbankRateOrItem(item, rate))
    }

    if (rate) {
      dispatch({
        type: API_CALL_SUCCESS,
        api: FETCH_BEDBANK_OFFERS_RATES,
        data: newRates,
        offerIds: [offer.id],
        filterKey: getBedbankRateKey(occupancies, checkIn, checkOut),
      })

      const session = await initBedbankSession(dispatch, {
        propertyId: offer.id,
        roomTypeId: roomId,
        roomRateId: rate.id,
        rateGroupId: rate.groupId,
        isFlightBundle: rate.isFlightBundle,
        region,
        rooms: occupancies,
        checkIn,
        checkOut,
        price: rate.totals.inclusive,
        memberInclusive: rate.totals.memberInclusive,
        csBooking: isSpoofed,
      })
      if (!('sessionId' in session)) {
        throw new Error(`Price is changed in initCheckoutBedbankSession, inclusive price is ${rate.totals.inclusive}, exclusive price is ${rate.totals.exclusive} and total price is ${rate.totals.total}`)
      }
      return {
        sessionId: session.sessionId,
        defaultBedGroupId: session.bedGroupId,
        roomRateId: rate.id,
      }
    } else {
      throw new Error('Room rate unavailable')
    }
  } else {
    throw new Error('Offer not found')
  }
}

export function updateArrivalFlightNumber(flightNumber: string): AppAction {
  return {
    type: CHECKOUT_UPDATE_ARRIVAL_FLIGHT_NUMBER,
    data: flightNumber,
  }
}

export function updateAgentInformation(agent: App.AgentDetails): AppAction {
  return {
    type: CHECKOUT_AGENT_BOOKING_DETAILS,
    data: agent,
  }
}

export function updateBusinessInformation(businessData: Record<string, unknown>): AppAction {
  return {
    type: CHECKOUT_BUSINESS_BOOKING_DETAILS,
    data: businessData,
  }
}

export function updateCsDepositPercentageOverride(depositOverride: boolean): AppAction {
  return {
    type: CHECKOUT_UPDATE_CS_DEPOSIT_OVERRIDE,
    depositOverride,
  }
}

export function setMerchantFeePaymentType(paymentType: App.MerchantFeePaymentType | null): AppAction {
  return {
    type: CHECKOUT_SET_MERCHANT_FEE_PAYMENT_TYPE,
    paymentType,
  }
}

export function setPayPalPaymentType(paymentType: typeof PAYPAL_PAYMENT_TYPE | typeof PAYLATER_PAYMENT_TYPE): AppAction {
  return {
    type: SET_PAYPAL_PAYMENT_TYPE,
    paymentType,
  }
}

export function logPaymentEvent(event: App.PaymentEventLog) {
  return {
    type: API_CALL,
    api: LOG_PAYMENT_EVENT,
    request: () => postPaymentEventLog(event),
  }
}

export function createStripePaymentMethod(stripe: Stripe, options: CreatePaymentMethodFromElements) {
  return {
    type: API_CALL,
    api: CREATE_STRIPE_PAYMENT_METHOD,
    request: async() => {
      const paymentMethodResponse = await stripe.createPaymentMethod(options)

      if (!paymentMethodResponse?.paymentMethod) {
        showSnackbar('Invalid card. Please check your card details and try again.', 'critical')
      }

      return paymentMethodResponse
    },
  }
}

export function setStripePaymentMethod(paymentMethod: App.StripePaymentMethod): AppAction {
  return {
    type: CHECKOUT_SET_STRIPE_PAYMENT_METHOD,
    paymentMethod,
  }
}

export function createCartQuote(cartId: string, callbackDate?: string): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const quoteStatus = state.checkout.cart.csCartQuoteStatus
    if (quoteStatus === 'created' || quoteStatus === 'loading') return

    /*
      * When spoofing from admin, the utm_medium can be either 'admin' or 'popup_store'
      * 'popup_store' indicates the cs agent is from the Chadstone store
      * 'admin' indicates the cs agent is from the call center
      * When the quote is created on Agent Hub, we don't want to store utms on svc-cart,
        that's why we only pass utms when spoofing from admin
    */
    const utms = state.utm.campaign === 'spoof' ? [state.utm.medium] : undefined

    dispatch({
      type: API_CALL,
      api: CHECKOUT_CREATE_CART_QUOTE,
      request: () => createQuote(cartId, callbackDate, utms),
    })
  }
}

export function updateCartQuote(keys: QuoteDedupeKeys, callbackDate?: string): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const { csCartQuoteStatus, csCartQuoteId } = state.checkout.cart
    if (csCartQuoteStatus !== 'created' || !csCartQuoteId) return
    dispatch({
      type: API_CALL,
      api: CHECKOUT_UPDATE_CART_QUOTE,
      request: () => updateQuote(csCartQuoteId, keys, callbackDate),
    })
  }
}

export function addArrivalDetails(itemId: string, arrivalDetails: App.ArrivalDetails): AppAction {
  return {
    type: CHECKOUT_ADD_ARRIVAL_DETAILS,
    itemId,
    arrivalDetails,
  }
}

export function setArrivalDetailsTime(itemId: string, arrivalTime: string): AppAction {
  return {
    type: CHECKOUT_SET_ARRIVAL_DETAILS_TIME,
    itemId,
    arrivalTime,
  }
}

export function setArrivalDetailsFlightNumber(itemId: string, arrivalFlightNumber: string): AppAction {
  return {
    type: CHECKOUT_SET_ARRIVAL_DETAILS_FLIGHT_NUMBER,
    itemId,
    arrivalFlightNumber,
  }
}

interface InitialiseMobileCheckoutParams {
  originAirportCode: string;
  offerId: string;
  checkIn: string;
  packageId: string;
  numberOfNights: number;
  occupancy: Array<App.Occupants>;
  roomRateId: string;
  destinationAirportCode: string;
  flightQuotedPrice?: number;
  luxPlusOfferId?: string;
  isLoyaltyRoomUpgrade?: boolean;
}

export function initialiseMobileFlightCheckout(data: InitialiseMobileCheckoutParams): AppAction {
  const {
    offerId,
    originAirportCode,
    checkIn,
    numberOfNights,
    packageId,
    roomRateId,
    occupancy,
    destinationAirportCode,
    flightQuotedPrice,
    luxPlusOfferId,
    isLoyaltyRoomUpgrade,
  } = data

  return async(dispatch, getState) => {
    const state = getState()
    const { geo, auth } = state
    const { currentRegionCode } = geo
    const channelMarkup = getChannelMarkup(state)

    // Allocate travellers to rooms
    const occupancyWithTravellers = allocateTravellersToRooms(
      occupancy,
      state.businessTraveller.selectedTravellerEmployeeIds,
      state.businessTraveller.selectedTravellerGuestIds,
    )

    const offer = (await getOfferById(offerId, {
      region: currentRegionCode,
      flightOrigin: originAirportCode,
      channelMarkup,
    })) as App.Offer | App.BedbankOffer

    if (!offer) {
      throw new CartInitError({
        type: 'unrecoverable_offer_error',
        code: 'offer_not_found',
        message: 'Offer not found',
      })
    }
    const checkOut = moment(checkIn).add(numberOfNights, 'days').format(ISO_DATE_FORMAT)

    const luxPlusEnabled = getIsLuxPlusEnabled(state)
    let luxPlusSubscriptionItems: Array<App.Checkout.LuxPlusSubscriptionItem | App.Checkout.SubscriptionJoinItem> = []
    if (luxPlusEnabled && luxPlusOfferId) {
      try {
        const luxPlusOffers = await getSubscriptionOffer(currentRegionCode)
        const luxPlusOffer = luxPlusOffers?.find(offer => offer.id === luxPlusOfferId)

        if (!luxPlusOffer) {
          throw new CartInitError({
            type: 'unrecoverable_offer_error',
            code: 'offer_not_found',
            message: 'LuxPlus offer not found',
          })
        }

        luxPlusSubscriptionItems = generateLuxPlusSubscriptionItems(luxPlusOffer)
      } catch(error) {
        throw new CartInitError({
          type: 'unrecoverable_offer_error',
          code: 'offer_not_found',
          message: `Error occurred while fetching LuxPlus offer ${error.message}`,
        })
      }
    }
    // addToCheckoutCart needs to happen before the enquiry to populate subscriber data in the session
    dispatch(addToCheckoutCart(luxPlusSubscriptionItems))

    if (offer.type === 'bedbank_hotel') {
      const authState: App.AuthState = state.auth

      const updatedRatesRequest = {
        checkIn,
        checkOut,
        rooms: occupancyWithTravellers,
        region: currentRegionCode,
        id: offerId,
        timezone: offer.property.timezone,
        isSpoofed: authState.account.isSpoofed,
      }

      const newRates = await getRatesForBedbankOffer(updatedRatesRequest)
      let rate: App.BedbankRate | undefined
      if (!packageId) {
        rate = newRates[0]
      } else if (!roomRateId) {
        rate = newRates.find(rate => rate.roomId === packageId)
      } else {
        rate = newRates.find(rate => rate.roomId === packageId && rate.id === roomRateId)
      }

      if (!rate) {
        throw new Error('Rate not found')
      }

      const session = await initBedbankSession(dispatch, {
        propertyId: offer.id,
        roomTypeId: rate.roomId,
        roomRateId: rate.id,
        rateGroupId: rate.groupId,
        isFlightBundle: rate.isFlightBundle,
        region: currentRegionCode,
        rooms: occupancyWithTravellers,
        checkIn,
        checkOut,
        price: rate.totals.inclusive,
        memberInclusive: rate.totals.memberInclusive,
        csBooking: auth.account.isSpoofed,
      })
      if (!('sessionId' in session)) {
        throw new Error('Price is changed')
      }

      const accommodationItems: Array<App.Checkout.BedbankHotelItem> =
        occupancyWithTravellers.map((occupancy) => {
          const accomodation: App.Checkout.BedbankHotelItem = {
            itemId: uuidV4(),
            offerId: offer.id,
            transactionKey: uuidV4(),
            itemType: CHECKOUT_ITEM_TYPE_BEDBANK,
            roomRateId,
            duration: numberOfNights,
            occupancy,
            checkIn,
            checkOut,
            bedGroupId: rate.bedGroups[0].id,
            isFlightBundle: rate.isFlightBundle,
            roomId: packageId,
            sessionId: session.sessionId,
          }

          return accomodation
        })

      const rooms = accommodationItems.map((item) => item.occupancy)
      const flightOccupants = countOccupantsForFlights(rooms)

      const flightItem = generateFlightCheckoutItem({
        originAirportCode,
        destinationAirportCode,
        bundledItemIds: accommodationItems.map((item) => item.itemId),
        occupants: flightOccupants,
        fareType: 'return',
        viewType: FlightViewTypes.TWO_ONE_WAYS,
        passengers: generatePassengersFromOccupants(flightOccupants),
        quotedFare: flightQuotedPrice,
      })

      dispatch(addItems([...accommodationItems, flightItem]))
    } else {
      const pkg = getPackageFromOffer(offer, packageId, numberOfNights)

      if (!pkg) {
        throw new Error('No Package found')
      }

      let loyaltyUpgradePkg: App.Package | undefined
      if (isLoyaltyRoomUpgrade && pkg.loyalty.targetUpgradePackageUniqueKey) {
        loyaltyUpgradePkg = offer.packages.find(p => p.uniqueKey === pkg.loyalty.targetUpgradePackageUniqueKey)
        if (!loyaltyUpgradePkg) {
          throw new Error('Loyalty upgrade package not found')
        }
      }

      const accommodationItems =
        occupancyWithTravellers.map((occupancy): App.Checkout.InstantBookingLEHotelItem => ({
          itemId: uuidV4(),
          offerId: offer.id,
          transactionKey: uuidV4(),
          itemType: CHECKOUT_ITEM_TYPE_LE_HOTEL,
          reservationType: 'instant_booking',
          packageId: loyaltyUpgradePkg ? loyaltyUpgradePkg.id : packageId,
          roomRateId: loyaltyUpgradePkg ? loyaltyUpgradePkg.roomRate!.id : roomRateId,
          duration: numberOfNights,
          occupancy,
          checkIn,
          checkOut,
        }))

      const rooms = accommodationItems.map((item) => item.occupancy)
      const flightOccupants = countOccupantsForFlights(rooms)

      const flightItem = generateFlightCheckoutItem({
        originAirportCode,
        destinationAirportCode,
        bundledItemIds: accommodationItems.map((item) => item.itemId),
        occupants: flightOccupants,
        fareType: 'return',
        viewType: FlightViewTypes.TWO_ONE_WAYS,
        passengers: generatePassengersFromOccupants(flightOccupants),
        quotedFare: flightQuotedPrice,
      })

      dispatch(addItems([...accommodationItems, flightItem]))
    }
  }
}

export function activateRebooking(rebookingID: string): AppAction {
  return {
    type: ACTIVATE_REBOOKING,
    data: { rebookingID },
  }
}

export function fetchCommissionPromoCode(force?: boolean): AppAction {
  return (dispatch, getState) => {
    if (!config.agentHub.isEnabled) {
      return
    }
    const state = getState()
    const regionCode = state.geo.currentRegionCode

    const commissionCartItems = stateToCommissionOrder(state)
    const isAncillaryPayment = isPostPurchaseAncillaryPayment(state)

    if (isAncillaryPayment) {
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_COMMISSION_PROMO_CODE,
      request: () => getAgentHubCommissionPromoCode(regionCode, commissionCartItems, force),
    })
  }
}

export function setPayToBankSelected(selectedPayToBank: App.PayToSupportedBank): AppAction {
  return {
    type: CHECKOUT_SET_PAYTO_BANK,
    selectedPayToBank,
  }
}

export function setCommsResubscribe(commsResubscribe: boolean): AppAction {
  return {
    type: CHECKOUT_SET_COMMS_RESUBSCRIBE,
    commsResubscribe,
  }
}

export function resubscribeUserForComms(): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    if (!state.checkout.form.commsResubscribe || !state.auth.account.memberId) return
    dispatch(updateLESubscriptionsV2({
      userId: state.auth.account.memberId,
      subscriptions: {
        smsSubscribed: true,
        emailSubscribed: true,
        appPushSubscribed: true,
        myJourneySubscribed: true,
        todaysEscapesSubscribed: true,
        curatedCollectionSubscribed: true,
        todaysEscapesCadence: 'WEEKLY',
      },
      source: SubscriptionSource.RESUBSCRIBE_MODAL,
    }))
    Analytics.trackClientEvent({
      subject: 'personalised-weekly',
      action: 'checkout',
      type: 'interaction',
      category: 'resubscribe',
    })
  }
}

export function generatePaymentLink(smsMessageTravellerName?: string, sendToMobileNumber?: string): AppAction {
  return (dispatch: AppDispatch, getState: () => App.State) => {
    const state = getState()

    dispatch({
      type: CHECKOUT_FETCHING_PAYMENT_LINK,
    })

    if (!state.checkout.orderId) {
      // adding timeout to show the error modal after the processing modal
      setTimeout(() => {
        dispatch({
          type: CHECKOUT_FETCHING_PAYMENT_LINK_FAILED,
        })
        dispatch(processingCancel())
        dispatch(genericOrderErrorModalOpen(['Unable to generate payment link']))
      }, 3000)
      return
    }

    const payload = {
      orderId: state.checkout.orderId,
      region: state.geo.currentRegionCode as Region,
      metadata: {
        itemNames: [] as Array<string>,
      },
      sendToMobileNumber,
      smsMessageTravellerName,
    }

    // brand is added by the request preprocessor
    const payloadWithoutBrand = payload as CreatePaymentLinkPayload

    createPaymentLink(payloadWithoutBrand)
      .then((paymentLink) => {
        dispatch({
          type: CHECKOUT_SET_PAYMENT_LINK,
          data: {
            securePaymentLink: paymentLink,
            securePaymentLinkType: sendToMobileNumber ? SECURE_PAYMENT_OPTIONS.LINK_VIA_SMS : SECURE_PAYMENT_OPTIONS.LINK_STANDALONE,
          },
        })
        dispatch(showSecurePaymentModal())
      })
      .catch(() => {
        dispatch({
          type: CHECKOUT_FETCHING_PAYMENT_LINK_FAILED,
        })
        dispatch(processingCancel())
        dispatch(genericOrderErrorModalOpen(['Unable to generate payment link']))
      })
  }
}

export function setOrderId(orderId: string): AppAction {
  return {
    type: CHECKOUT_SET_ORDER_ID,
    orderId,
  }
}

export function setCheckoutCartMode(mode: App.CheckoutCartMode): AppAction {
  return {
    type: CHECKOUT_SET_MODE,
    mode,
  }
}

export function setHasCarHireIntention(hasCarHireIntention: boolean): AppAction {
  return {
    type: CHECKOUT_SET_HAS_CAR_HIRE_INTENTION,
    hasCarHireIntention,
  }
}

export function setAgentHubPaymentSetup(agentHubPaymentMode: App.AgentHubPaymentMode): AppAction {
  return {
    type: CHECKOUT_SET_AGENT_HUB_PAYMENT_SETUP,
    agentHubPaymentMode,
  }
}

export function setLoyaltyDiscountOnTransferItem(): AppAction {
  return (dispatch, getState) => {
    const state = getState()

    const transferItem = getExperienceItems(state)[0]
    if (
      transferItem?.experienceId === magicLoyaltyTransferExperienceId &&
      transferItem?.tickets.some(ticket => ticket.ticketId === magicLoyaltyTransferExperienceTicketId && !ticket.loyaltyTransferDiscount)
    ) {
      const newItem: App.Checkout.ExperienceItem = {
        ...transferItem,
        tickets: transferItem.tickets.map(ticket => ({
          ...ticket,
          loyaltyTransferDiscount: ticket.ticketId === magicLoyaltyTransferExperienceTicketId,
        })),
      }
      dispatch(updateCheckoutItem(newItem))
    }
  }
}

export function refetchCommissionPromoCode() {
  return (dispatch: AppDispatch) => {
    dispatch(resetCheckoutCommission())
    dispatch(fetchCommissionPromoCode(true))
  }
}

export function restoreCheckoutLoyaltyPointsToBurn(pointsToBurn: number | undefined): AppAction {
  return {
    type: CHECKOUT_RESTORE_LOYALTY_UPDATE_POINTS_TO_BURN,
    pointsToBurn,
  }
}

export function restoreCheckoutPromoCode(promoCode: string): AppAction {
  return (dispatch) => {
    dispatch(addPromoCode(promoCode))
    dispatch({
      type: CHECKOUT_CLEAR_RESTORED_PROMO_CODE,
    })
  }
}

export function restoreCheckoutUseCredit(useCredit: boolean): AppAction {
  return (dispatch) => {
    dispatch(setUsingCredit(useCredit))
    dispatch({
      type: CHECKOUT_CLEAR_RESTORED_USE_CREDIT,
    })
  }
}

export function setApprovalRequestId(approvalRequestId: string): AppAction {
  return {
    type: CHECKOUT_SET_APPROVAL_REQUEST_ID,
    approvalRequestId,
  }
}

export function clearApprovalRequestId(): AppAction {
  return {
    type: CHECKOUT_CLEAR_APPROVAL_REQUEST_ID,
  }
}

export function updateTravellerFormPrerequisite(key: keyof App.CheckoutState['travellerFormPrerequisites'], completed: boolean): AppAction {
  return {
    type: CHECKOUT_UPDATE_TRAVELLER_FORM_PREREQUISITE,
    key,
    completed,
  }
}

export function removeTravellerFormPrerequisite(key: keyof App.CheckoutState['travellerFormPrerequisites']): AppAction {
  return {
    type: CHECKOUT_REMOVE_TRAVELLER_FORM_PREREQUISITE,
    key,
  }
}

export function toggleFailedItems(): AppAction {
  return {
    type: CHECKOUT_TOGGLE_FAILED_ITEMS,
  }
}

export function updateCheckoutLoyaltyPointsToBurn(pointsToBurn: number | undefined): AppAction {
  return (dispatch) => {
    dispatch({
      type: CHECKOUT_LOYALTY_UPDATE_POINTS_TO_BURN,
      pointsToBurn,
    })
  }
}

export function applyCheckoutLoyaltyRoomUpgrade(
  item: App.Checkout.LEAccommodationItem,
  upgrade: boolean,
): AppAction {
  return (dispatch) => {
    const updatedItem: App.Checkout.LEAccommodationItem = {
      ...item,
      hasLoyaltyBenefitRoomUpgrade: upgrade,
    }
    dispatch(updateCheckoutItem(updatedItem))
  }
}
